import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/homepage/components/BenefitsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/homepage/components/NewsletterCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/ui/AppImage.tsx");
